import { ApiBase } from './ApiBase';
class OffersCombinedApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getOfferCombined = (offerId) => {
            return this.get(`offers-combined/${offerId}`);
        };
        this.createOfferCombined = () => {
            return this.post('offers-combined');
        };
        this.updateOfferCombined = (offerId, body) => {
            return this.patch(`offers-combined/${offerId}`, body);
        };
        this.deleteOfferCombined = (offerId) => {
            return this.delete(`offers-combined/${offerId}`);
        };
        this.detachOfferCombined = (offerId, detachOfferId) => {
            return this.delete(`offers-combined/${offerId}/offers/${detachOfferId}`);
        };
        this.getOffersPicker = (offerId, params) => {
            return this.get(`offers-combined/${offerId}/offers/picker`, params);
        };
    }
}
export const OffersCombinedApiClient = new OffersCombinedApiClientModel();
